import { Reducer } from "@reduxjs/toolkit"
import { EstadoRequisicao } from "store/types"
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils"
import { UnidadesResponsaveisAction } from "./UnidadesResponsaveis.action"
import { UnidadesReponsaveisActionTypes, UnidadesResponsaveisState } from "./UnidadesResponsaveis.types"


const estadoInicial: UnidadesResponsaveisState = {
  estado: EstadoRequisicao.OCIOSO,
  currentRequestId: undefined,

  erros: undefined,

  unidadesResponsaveis: [],
  responsaveisTecnicos: [],
}


export const unidadesResponsaveisReducer: Reducer<UnidadesResponsaveisState, UnidadesReponsaveisActionTypes> = (state = estadoInicial, action): UnidadesResponsaveisState => {
  if (UnidadesResponsaveisAction.carregar.pending.match(action)) {
    if (state.estado !== EstadoRequisicao.OCIOSO) {
      return state;
    }

    return {
      ...state,

      estado: EstadoRequisicao.CARREGANDO,
      currentRequestId: action.meta.requestId,
      erros: undefined,
    }

  } else if (UnidadesResponsaveisAction.carregar.fulfilled.match(action)) {
    if (action.payload === undefined
     || state.estado !== EstadoRequisicao.CARREGANDO
     || state.currentRequestId !== action.meta.requestId) {
      return state;
    }

    return {
      ...state,

      estado: EstadoRequisicao.BEM_SUCEDIDO,
      currentRequestId: undefined,
      erros: undefined,

      unidadesResponsaveis: action.payload.unidadesResponsaveis,
      responsaveisTecnicos: action.payload.responsaveisTecnicos
    }

  } else if (UnidadesResponsaveisAction.carregar.rejected.match(action)) {
    if (state.estado !== EstadoRequisicao.CARREGANDO
     || state.currentRequestId !== action.meta.requestId) {
      return state;
    }

    return {
      ...state,

      estado: EstadoRequisicao.FALHOU,
      currentRequestId: undefined,
      erros: action.payload as ResponseError,
    }
  }


  return state;
}
